import { merge } from 'lodash';
import type { AnyStateMachine } from 'xstate';
import { EnrollmentMachine } from '~/machines/enrollment-selection';
import { ContextSendMatch } from '~/machines/utils/types';
import { DeepPartial } from '~/typings/utils';
import { store } from '~/utils/store';
import { Credentials, CredentialsProps } from './credentials.component';

export type CredentialsContainerProps = {
  micro: ContextSendMatch<EnrollmentMachine>;
  funnel: ContextSendMatch<AnyStateMachine>;
  overrideCopy?: CredentialsProps['overrideCopy'];
  overrideProps?: DeepPartial<CredentialsProps>;
};

export const CredentialsContainer = ({
  micro: { context, send },
  overrideCopy,
  overrideProps,
}: CredentialsContainerProps) => {
  const { utility } = context.funnelPacket;
  const props: CredentialsProps = {
    context: {
      verificationStatus: context.funnelPacket.utilityCredential.verificationStatus,
      utility: context.funnelPacket.utility,
      utilityConnectToken: context.utilityConnectToken,
      user: context.funnelPacket.user,
      funnelId: store.get('ACTIVE_FUNNEL_ID'),
    },
    goTo: {
      accountNumber: context.enrollmentOptions.includes('partner_provided')
        ? () => send({ type: 'CHOOSE_ACCOUNT_NUMBER' })
        : undefined,
      billUpload: context.enrollmentOptions.includes('bill_capture')
        ? () => send({ type: 'CHOOSE_BILL_UPLOAD' })
        : undefined,
    },
    error: context.errors.utilityConnect,
    next: data => send({ type: 'CREDENTIAL_RESULT', data }),
    overrideCopy: !(utility.state.abbreviation === 'IL')
      ? overrideCopy
      : () => {
          return {
            ...overrideCopy,
            disclaimer: `Arcadia is a service provider independent of ${utility.displayName} and is committed to putting you and the planet first. Arcadia is not affiliated with ${utility.displayName}, and ${utility.displayName} has not approved this product.`,
          };
        },
    skip: context.canSkipUtilityConnect ? () => send('SKIP_UTILITY_CONNECT') : undefined,
  };

  return <Credentials {...merge(props, overrideProps)} />;
};
